import React, { useEffect, useState } from 'react';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedin
} from 'react-icons/fa';
import {
  FooterContainer,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink
} from './Footer.elements';

function Footer() {
    const [data, setdata] = useState([]);
    const [footerdata, setfooterdata] = useState([]);
    const [orgId, setOrgId] = useState(null)
        
    const GetImageData = async (orgId) => {
        const sendData2 = {
            OrgId: Number(orgId),

        };

        //console.log(sendData2);

        try {
            const response = await fetch(`https://zaingielatestapi.azurewebsites.net/api/Main/GetOrganizationInfo`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(sendData2),
            });

            const data = await response.json();

            //console.log("Footer: ", data)
            // Convert strings to booleans (supports array or object)

            setdata(data);
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    };

    const Getfooterdata = async (orgId) => {
        const sendData2 = {
            OrgId: Number(orgId),
            ActiveStatus: 'A',
            Type: 'Zangie_DynamicWebsiteFooter',
        };

        //console.log(sendData2);

        try {
            const response = await fetch(`https://zaingielatestapi.azurewebsites.net/api/Bill/Getwebsitedatadynamic`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(sendData2),
            });

            const dataf = await response.json();
            //console.log("Raw data: 1", dataf);
            //setfooterdata(data);

            const data = dataf.filter(s => s.headline !== "Book link")

            const groupedByHeadline = data.reduce((acc, item) => {
                const { headline, description } = item;

                if (!acc[description]) {
                    acc[description] = [];
                }

                // Only push unique descriptions
                if (!acc[description].includes(headline)) {
                    acc[description].push(headline);
                }

                return acc;
            }, {});

            //console.log("group: ", groupedByHeadline);
            setfooterdata(groupedByHeadline);
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    };



    useEffect(() => {
        const fetchData = async () => {
            const sendData2 = {
                ActualWebsite: window.location.hostname,
                //ActualWebsite:"bajrangseva.com",
                //ActualWebsite: "eh.mounts.in",
                //ActualWebsite: "healcop.com",
                OrgName: "test"

            };

            try {
                await fetch(`https://zaingielatestapi.azurewebsites.net/api/FLOW/Getorgiddynamic`, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(sendData2),
                }).then((response) => response.json())
                    .then((data) => {
                        const orgid = data.orgId;
                        setOrgId(data.orgId)
                        //console.log("Org: ", data.orgId)
                        GetImageData(orgid)
                        //Getfooterdata(2099)
                        Getfooterdata(orgid)
                    });
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);
  return (
    <FooterContainer orgId={orgId}>
     
      <FooterLinksContainer>
              <FooterLinksWrapper>
                  {data?.orgAddress === null ? null : <div style={{
                      flex: '1',
                      minWidth: '250px',
                      maxWidth: '350px', 
                      padding: '20px',
                      backgroundColor: '#0c0c0c',
                      color: '#fff',
                      borderRadius: '10px',
                      marginBottom: '20px'
                  }}>
                      <h3 style={{ color: '#fdbb2d', marginBottom: '10px' }}>Contact Address</h3>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                          <div>
                              <span role="img" aria-label="location">📍</span>


                              {[
                                  data?.orgName,
                                  data?.orgAddress,
                                  data?.orgCity,
                                  data?.orgState,
                                  data?.orgCountry,
                                  data?.orgPin
                              ]
                                  .filter((item) => item !== null && item !== undefined && item !== "")
                                  .join(", ")}
                              <br />
                              {/*<b style={{ color: '#fff' }}>GSTN NO </b>-  {data.vatNumber}<br />*/}


                          </div>

                          {data.vatNumber === null || data.vatNumber === "" ? null : <div> <span role="img" aria-label="location">📍 GST : </span> {data.vatNumber}</div>}

                          <div>
                              <span role="img" aria-label="phone">📞</span> +{data.orgLandline1}
                          </div>
                      </div>
                  </div>
                  }
               

                  

                  {Object.entries(footerdata).map(([sectionTitle, items]) => (

                          <FooterLinkItems>
                              <FooterLinkTitle>{sectionTitle}</FooterLinkTitle>
                              
                              
                                  {Array.isArray(items) &&
                                  items.map((item, index) => (
                                      item === "Contact Us" ?<FooterLink to='/Contact'>Contact Us</FooterLink>:
                                          <FooterLink key={index} to={`dynamic?page=${encodeURIComponent(item)}`}>
                                              {item}
                                          </FooterLink>
                                      ))}
                              
                              </FooterLinkItems>
                      ))}
                  {/*<FooterLink to='/Contact'>Contact Us</FooterLink>*/}
          
        </FooterLinksWrapper>
      
      </FooterLinksContainer>
      <SocialMedia>
        <SocialMediaWrap>
          <SocialLogo to='/'>

                      {data.orgName}
          </SocialLogo>
                  <WebsiteRights>
                      Copyright © {new Date().getFullYear()}
                  </WebsiteRights>

          <SocialIcons>
                      <SocialIconLink href={data.facebookId} target='_blank' aria-label='Facebook'>
              <FaFacebook />
            </SocialIconLink>
                      <SocialIconLink href={data.instagramid} target='_blank' aria-label='Instagram'>
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink
                          href={data.youTubeId}
              rel='noopener noreferrer'
              target='_blank'
              aria-label='Youtube'
            >
              <FaYoutube />
            </SocialIconLink>
                      <SocialIconLink href={data.twitterId} target='_blank' aria-label='Twitter'>
              <FaTwitter />
            </SocialIconLink>
                      <SocialIconLink href={data.linkedinId}  target='_blank' aria-label='LinkedIn'>
              <FaLinkedin />
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
}

export default Footer;
